var map = {
	"./slide-1.jpg": "69dc",
	"./slide-10.jpg": "bea0",
	"./slide-11.jpg": "c7ef",
	"./slide-12.jpg": "e3f6",
	"./slide-13.jpg": "8337",
	"./slide-14.jpg": "0025",
	"./slide-15.jpg": "dfd4",
	"./slide-16.jpg": "5937",
	"./slide-17.jpg": "2e2d",
	"./slide-18.jpg": "7a0e",
	"./slide-19.jpg": "8258",
	"./slide-2.jpg": "caac",
	"./slide-20.jpg": "b2ed",
	"./slide-21.jpg": "c2ec",
	"./slide-22.jpg": "cde5",
	"./slide-23.jpg": "4e2b",
	"./slide-24.jpg": "92e4",
	"./slide-25.jpg": "240b",
	"./slide-26.jpg": "8df40",
	"./slide-27.jpg": "6164",
	"./slide-28.jpg": "181a",
	"./slide-29.jpg": "784c",
	"./slide-3.jpg": "be1e",
	"./slide-30.jpg": "44dc3",
	"./slide-31.jpg": "5b37",
	"./slide-32.jpg": "cf5e",
	"./slide-4.jpg": "bfe0",
	"./slide-5.jpg": "b20ab",
	"./slide-6.jpg": "b3f1",
	"./slide-7.jpg": "2eb4",
	"./slide-8.jpg": "f9e9",
	"./slide-9.jpg": "d054"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c8fe";